export default __webpack_public_path__ + "static/media/11.1d15d46b.jpg";